import React from "react";
import { LOGO_URL, COMPANY } from "@/lib/constants";

/**
 * Logo mark. Uses the shared `#knockout-white` SVG filter (mounted in App.js)
 * to strip the near-white background from the PNG so only the colored logo
 * shows through against any surface.
 */
export function LogoMark({ className = "h-10 w-10" }) {
  return (
    <img
      src={LOGO_URL}
      alt={COMPANY.name}
      className={`${className} object-contain shrink-0`}
      style={{ filter: "url(#knockout-white)" }}
      data-testid="brand-logo-mark"
    />
  );
}

export function LogoLockup({ size = "md" }) {
  const dim = size === "lg" ? "h-14 w-14" : "h-11 w-11";
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo-lockup">
      <LogoMark className={dim} />
      <div className="flex flex-col leading-tight">
        <span className="font-display font-semibold text-ink text-base sm:text-lg tracking-tight">
          Mavericks
        </span>
        <span className="font-mono text-[10px] sm:text-[11px] uppercase tracking-[0.2em] text-muted-warm">
          PBX Solutions
        </span>
      </div>
    </div>
  );
}
